import { Component, OnInit } from '@angular/core';
import { FMV_RANGES } from 'app/shared/data/constants';

@Component({
  selector: 'app-rate-methodology',
  templateUrl: './rate-methodology.component.html',
  styleUrls: ['./rate-methodology.component.scss']
})
export class RateMethodologyComponent implements OnInit {
  fmvRates = FMV_RANGES;
  constructor() { }

  ngOnInit() {
  }

}
